export default function SvgRight5() {
    return (
      <>
     <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20px"
      cursor="pointer"
      viewBox="0 0 24 24"
     >
      <path
        fill="#141124"
        d="M10.22 9.28a.75.75 0 010-1.06l2.72-2.72H.75a.75.75 0 010-1.5h12.188L10.22 1.281A.75.75 0 1111.281.22l4 4a.749.749 0 010 1.06l-4 4a.75.75 0 01-1.061 0z"
        transform="translate(4.25 7.25)"
      ></path>
    </svg>
   </>
  );
}